'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';
import { toast } from 'sonner';

// Backend integration point: replace with /api/users/:id/viewings
const viewings = [
  { id: 'view-001', property: 'Palm Signature Villa', location: 'Palm Jumeirah, Dubai', date: '08 Jun 2026', time: '03:00 PM', agent: 'Nadia Petrov', agencyPhone: '+971 55 123 4567', status: 'Confirmed' },
  { id: 'view-002', property: 'Dubai Marina Penthouse', location: 'Dubai Marina, Dubai', date: '12 Jun 2026', time: '11:00 AM', agent: 'Omar Hassan', agencyPhone: '+971 55 987 6543', status: 'Pending' },
];

const statusColors: Record<string, string> = {
  Confirmed: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Pending: 'bg-amber-50 text-amber-700 border-amber-200',
  Cancelled: 'bg-red-50 text-red-700 border-red-200',
};

export default function UpcomingViewings() {
  return (
    <div className="bg-card border border-border rounded-2xl p-6 shadow-card">
      <div className="flex items-center justify-between mb-5">
        <h2 className="font-bold text-foreground text-lg">Upcoming Viewings</h2>
        <button className="text-primary text-sm font-semibold hover:underline">Schedule New</button>
      </div>

      {viewings.length === 0 ? (
        <div className="py-10 text-center">
          <Icon name="CalendarDaysIcon" size={36} className="text-muted-foreground/40 mx-auto mb-3" />
          <h3 className="font-bold text-foreground mb-1">No viewings scheduled</h3>
          <p className="text-muted-foreground text-sm">Book a viewing on any property listing to get started.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {viewings.map((v) => (
            <div key={v.id} className="flex items-center gap-4 p-4 rounded-xl border border-border hover:border-primary/30 hover:bg-muted/30 transition-all">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex flex-col items-center justify-center flex-shrink-0">
                <div className="text-primary font-extrabold text-sm font-tabular">{v.date.split(' ')[0]}</div>
                <div className="text-primary/70 text-xs">{v.date.split(' ')[1]}</div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-bold text-foreground text-sm line-clamp-1">{v.property}</div>
                <div className="text-muted-foreground text-xs flex items-center gap-1 mt-0.5">
                  <Icon name="MapPinIcon" size={11} />{v.location}
                </div>
                <div className="flex items-center gap-3 mt-1.5">
                  <span className="text-xs text-foreground/70 flex items-center gap-1">
                    <Icon name="ClockIcon" size={11} />{v.time}
                  </span>
                  <span className="text-xs text-foreground/70 flex items-center gap-1">
                    <Icon name="UserIcon" size={11} />{v.agent}
                  </span>
                </div>
              </div>
              <div className="flex flex-col items-end gap-2 flex-shrink-0">
                <span className={`text-xs font-semibold px-2 py-1 rounded-full border ${statusColors[v.status]}`}>{v.status}</span>
                <div className="flex items-center gap-1.5">
                  <button
                    onClick={() => toast.info(`Calling ${v.agent}...`)}
                    className="w-7 h-7 rounded-lg bg-primary/10 text-primary flex items-center justify-center hover:bg-primary hover:text-white transition-all"
                    aria-label="Call agent"
                  >
                    <Icon name="PhoneIcon" size={12} />
                  </button>
                  <button
                    onClick={() => toast.success('Viewing cancelled')}
                    className="w-7 h-7 rounded-lg bg-red-50 text-red-500 flex items-center justify-center hover:bg-red-500 hover:text-white transition-all"
                    aria-label="Cancel viewing"
                  >
                    <Icon name="XMarkIcon" size={12} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}